/**
 * @generated SignedSource<<e3dc6280502d8584c70c4cceed65093d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespShippingReturns_user$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedDetailShipping_user">;
  readonly " $fragmentType": "PdpRespShippingReturns_user";
};
export type PdpRespShippingReturns_user$key = {
  readonly " $data"?: PdpRespShippingReturns_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespShippingReturns_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespShippingReturns_user",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedDetailShipping_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "b45d1a2d61b95a025241644cebf4ce23";

export default node;
